import { render } from "./DesignPortfolio.vue?vue&type=template&id=fcb5b040&scoped=true"
import script from "./DesignPortfolio.vue?vue&type=script&lang=js"
export * from "./DesignPortfolio.vue?vue&type=script&lang=js"

import "./DesignPortfolio.vue?vue&type=style&index=0&id=fcb5b040&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb5b040"]])

export default __exports__